import React, { useContext } from 'react';
import ScreenTextContext from '../../../contexts/ScreenTextContext';

export const Feedback = ({children}) => {

  const { screenText } = useContext(ScreenTextContext);  

  if (!screenText || !screenText.play ) {
    return ''; // Should return error? Loading?
  }

  return (
    <div className="feedback">

      <img src={`${process.env.PUBLIC_URL}/assets/images/icon-remember.png`} alt="" />

      <div className="feedback__text-wrapper">
        <div className="feedback__title">
          {screenText.play.feedbackHeader}
        </div>

        <div className="feedback__body">
          {children}
        </div>
      </div>
      
      <div className="dotted-line"></div>

    </div>
  )
}